export default __webpack_public_path__ + "static/enhancing-operational-efficiency-with-digital-activity-scheduler-612126f9a5b6c9ae948e57312505a6e1.png";